// Single source of truth for tab identity, shared by app-main.js and any
// tab that needs to navigate to another tab (e.g. markup-storage-tab.js
// jumping to the Renderer tab). Avoids hardcoding tab id numbers or route
// name strings in more than one place.
export const TABS = Object.freeze({
    PRODUCTS: '1',
    CHANGE_DETECTOR: '2',
    RENDERER: '3',
    CHANGE_DETECTOR_LOGS: '4',
    MARKUP_STORAGE: '5',
    SETTINGS: '6',
    PRODUCT_CATALOG: '7',
});

export const ROUTES = Object.freeze({
    PRODUCTS: 'products',
    CHANGE_DETECTOR: 'change-detector',
    RENDERER: 'renderer',
    CHANGE_DETECTOR_LOGS: 'change-detector-logs',
    MARKUP_STORAGE: 'markup-storage',
    SETTINGS: 'settings',
    PRODUCT_CATALOG: 'product-catalog',
});
